import React from 'react';
import { translateText } from '../../../helpers/LanguageHelper';
import { Row, Col } from 'reactstrap';
import ProductBox from './ProductBox';
import Skeleton from './Skeleton/Skeleton';
import CatalogStatus from './CatalogStatus';
import useHomeCatalog from '../../../helpers/useHomeCatalog';

const PopularProducts = ({ hoverEffect }) => {
    const { products: ProductsList, loading: productsLoading, error, retry } = useHomeCatalog();
    return (
        <>
            
            <section className="product section-pb-space mb--5 ukl-bottom-products ukl-new-products-grid">
                <div className="custom-container">
                    <div className="ukl-bottom-products__header">
                        <h2>{translateText("Butter Shipped from Uthukuli")}</h2>
                        <p>{translateText("Discover the authentic taste of carefully crafted butter from the heart of Uthukuli.")}</p>
                    </div>
                    <Row className="ukl-product-row">
                        <Col className="pe-0">
                            <div className="ratio_asos">

                                <div>
                                    <CatalogStatus error={error} loading={productsLoading} count={ProductsList.length} retry={retry} />
                                    {productsLoading && ProductsList.length === 0 ? (
                                        <Skeleton />
                                    ) : ProductsList.length === 0 ? (
                                        <p className="text-center">{translateText(error ? "" : "No products available")}</p>
                                    ) : (
                                        <Row className="ukl-product-row">
                                            {ProductsList && ProductsList.map((itm, i) => (
                                                    <Col xs="6" md="4" lg="3" key={itm.ProductId} className="ukl-product-column">
                                                        <ProductBox
                                                            hoverEffect={hoverEffect}
                                                            item={itm}
                                                            layout=""
                                                            ProductDetailPageForceUpload={false}
                                                            fitImage={true}
                                                        />
                                                    </Col>
                                            ))}
                                        </Row>
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    );
};

export default PopularProducts;
